import { Tag } from '@televet/kibble-ui';
import partial from 'lodash-es/partial';
import React from 'react';
import { FilterBaseOption } from './types';

type FiltersOverviewProps = {
  selectedOptions: FilterBaseOption[];
  isReadOnly?: boolean;
  handleToggleOption: (option: FilterBaseOption) => void;
};

export const FiltersOverview = ({
  selectedOptions,
  isReadOnly,
  handleToggleOption,
}: FiltersOverviewProps): JSX.Element => {
  return (
    <>
      {selectedOptions.map((option) => {
        const { value, label, color } = option;
        return (
          <Tag
            key={value.toString()}
            color={color ? 'white' : 'text.default'}
            bg={color || 'background.alpha'}
            size="sm"
            label={label}
            closeButtonDisplay={isReadOnly ? 'never' : 'always'}
            onClose={partial(handleToggleOption, option)}
          />
        );
      })}
    </>
  );
};
